import {VECTOR3} from '../../index.js';

/**
 * Creates Hypercube.js fogs.
 * @example
 * const fog = new Fog(color, distancefogbegin, distancefogmaximum, density);
 */
class Fog {

    /**
     * Stores the color.
     * @type {vector3}
     * @protected
     */
    $color;

    /**
     * Stores the density.
     * @type {number}
     * @protected
     */
    $density;

    /**
     * Stores the minimal distance for the fog to begin.
     * @type {number}
     * @protected
     */
    $distancefogbegin;

    /**
     * Stores the distance for the fog to be at its maximum.
     * @type {number}
     * @protected
     */
    $distancefogmaximum;

    /**
     * Gets the color.
     * @type {vector3}
     * @public
     * @readonly
     */
    get color() {

        return this.$color;
    };

    /**
     * Gets the density.
     * @type {number}
     * @public
     * @readonly
     */
    get density() {

        return this.$density;
    };

    /**
     * Gets the minimal distance for the fog to begin.
     * @type {number}
     * @public
     * @readonly
     */
    get distancefogbegin() {

        return this.$distancefogbegin;
    };

    /**
     * Gets the distance for the fog to be at its maximum.
     * @type {number}
     * @public
     * @readonly
     */
    get distancefogmaximum() {

        return this.$distancefogmaximum;
    };

    /**
     * Creates a new Hypercube.js fog.
     * @param {vector3} $color The color of the fog.
     * @param {number} $distancefogbegin The minimal distance for the fog to begin.
     * @param {number} $distancefogmaximum The distance for the fog to be at its maximum.
     * @param {number} $density The density of the fog.
     */
    constructor($color, $distancefogbegin, $distancefogmaximum, $density) {

        this.$color = VECTOR3.clone($color);
        this.$distancefogbegin = $distancefogbegin;
        this.$distancefogmaximum = $distancefogmaximum;
        this.$density = $density;
    }
}

export {

    Fog
};

export default Fog;
